module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst fieldConfig = model.config || {}\nconst fieldsConfig = fieldConfig.fields || {}\nconst additionalClasses = [`textfield-${((model.atom || {}).dataType || '')}`]\nif(model.disabled)                              additionalClasses.push('disabled');\nif(typeof(additionalCSSClass) !== 'undefined')  additionalClasses.push(additionalCSSClass);\nif(model.additionalCSSClass)                    additionalClasses.push(model.additionalCSSClass);\nif(model.innerTitle)                            additionalClasses.push('hasInnerTitle');\nconst fieldClasses = []\nif(config.bootstrapVersion) fieldClasses.push('form-control');\n// model[model.dataFlag] is used for downwards compatibility (e.g., vbst partnerPropertiesForm will be rendered by server)\nconst value = model.dataFormatted || model[model.dataFlag || '---noDataFlag---'] || (model.config || {}).defaultValue\n%><div class=\"<%- additionalClasses.join(' ') %>\"><%\n%><div class=\"inputContainer\"><%\n%><input\ndata-field-type=\"text\"\ntype=\"text\"\ndata-field-code=\"<%- model.fieldCode %>\"\nvalue=\"<%= value %>\"\n<%- (model.disabled ? 'disabled=\"disabled\"' : '') %>\nplaceholder=\"<%= model.placeholder || '' %>\"\nclass=\"<%= fieldClasses.join(' ') %>\"\n<%- fieldConfig.inputSize ? `size=\"${fieldConfig.inputSize}\"` : '' %>\n/><%\nif((fieldsConfig.generate || {}).length > 0){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'generate', context: 'text', symbolOnly: true } }); %><%\n}\nif(fieldsConfig.copyToClipboard){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'copyToClipboard', context: 'text', symbolOnly: true } }); %><%\n}\n%></div><%\nif(model.innerTitle){\n%><div class=\"innerTitle\"><%= model.innerTitle %></div><%\n}\nif((model.config || {}).keyDownLabel && (model.config || {}).keyDownLabelInline !== false){\n%><label title=\"<%= model.keyDownLabel || '' %>\"><%= model.keyDownLabel || '' %></label><%\n}\n%></div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\fields\\text.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const fieldConfig = model.config || {}
const fieldsConfig = fieldConfig.fields || {}
const additionalClasses = [`textfield-${((model.atom || {}).dataType || '')}`]
if(model.disabled)                              additionalClasses.push('disabled');
if(typeof(additionalCSSClass) !== 'undefined')  additionalClasses.push(additionalCSSClass);
if(model.additionalCSSClass)                    additionalClasses.push(model.additionalCSSClass);
if(model.innerTitle)                            additionalClasses.push('hasInnerTitle');
const fieldClasses = []
if(config.bootstrapVersion) fieldClasses.push('form-control');
// model[model.dataFlag] is used for downwards compatibility (e.g., vbst partnerPropertiesForm will be rendered by server)
const value = model.dataFormatted || model[model.dataFlag || '---noDataFlag---'] || (model.config || {}).defaultValue

    ; __line = 13
    ; __append("<div class=\"")
    ; __append( additionalClasses.join(' ') )
    ; __append("\">")
    ; 

    ; __line = 14
    ; __append("<div class=\"inputContainer\">")
    ; 

    ; __line = 15
    ; __append("<input\ndata-field-type=\"text\"\ntype=\"text\"\ndata-field-code=\"")
    ; __line = 18
    ; __append( model.fieldCode )
    ; __append("\"\nvalue=\"")
    ; __line = 19
    ; __append(escapeFn( value ))
    ; __append("\"\n")
    ; __line = 20
    ; __append( (model.disabled ? 'disabled="disabled"' : '') )
    ; __append("\nplaceholder=\"")
    ; __line = 21
    ; __append(escapeFn( model.placeholder || '' ))
    ; __append("\"\nclass=\"")
    ; __line = 22
    ; __append(escapeFn( fieldClasses.join(' ') ))
    ; __append("\"\n")
    ; __line = 23
    ; __append( fieldConfig.inputSize ? `size="${fieldConfig.inputSize}"` : '' )
    ; __append("\n/>")
    ; __line = 24
    ; 
if((fieldsConfig.generate || {}).length > 0){

    ; __line = 26
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'generate', context: 'text', symbolOnly: true } }) )
    ; 
}
if(fieldsConfig.copyToClipboard){

    ; __line = 29
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'copyToClipboard', context: 'text', symbolOnly: true } }) )
    ; 
}

    ; __line = 31
    ; __append("</div>")
    ; 
if(model.innerTitle){

    ; __line = 33
    ; __append("<div class=\"innerTitle\">")
    ; __append(escapeFn( model.innerTitle ))
    ; __append("</div>")
    ; 
}
if((model.config || {}).keyDownLabel && (model.config || {}).keyDownLabelInline !== false){

    ; __line = 36
    ; __append("<label title=\"")
    ; __append(escapeFn( model.keyDownLabel || '' ))
    ; __append("\">")
    ; __append(escapeFn( model.keyDownLabel || '' ))
    ; __append("</label>")
    ; 
}

    ; __line = 38
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\fields\text.ejs

}